export enum PoDetailTypeCode {
  Order = 'ORDER',
  // Sample = 'SAMPLE',
  Stock = 'STOCK',
  Special = 'SPECIAL',
  // Replace = 'REPLACE'
}
